import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Link din emailul „comandă nefinalizată" (?reluare=TOKEN): tokenul e scos IMEDIAT din URL,
// înainte să se încarce GA4 sau altceva - nu ajunge în analytics, istoric sau Referer. Restul (cod, utm) rămâne.
try {
  const params = new URLSearchParams(window.location.search);
  const resume = params.get('reluare');
  if (resume) {
    if (/^[a-f0-9]{32}$/.test(resume)) window.__cfResumeToken = resume;
    params.delete('reluare');
    const qs = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash);
  }
} catch (e) { /* fără efect */ }

const rootElement = document.getElementById('root');

// react-snap: dacă există HTML pre-randat, hydrate; altfel, render normal
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
